export const GAME112DAY1VOTES = [
  {
    id: 3,
    timestamp: '2023-06-04T16:51:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [],
      'Erinyes': [],
      'Tatsu': [],
      'DigitalDude': [],
      'Gajeel': [],
      'Shad': [],
      'James': [],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 16,
    timestamp: '2023-06-04T19:11:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [],
      'Erinyes': [],
      'Tatsu': [],
      'DigitalDude': [],
      'Gajeel': [],
      'Shad': [],
      'James': [{player: 'GB', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 25,
    timestamp: '2023-06-04T21:39:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [],
      'DigitalDude': [],
      'Gajeel': [],
      'Shad': [],
      'James': [{player: 'GB', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 44,
    timestamp: '2023-06-04T22:38:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [],
      'DigitalDude': [],
      'Gajeel': [],
      'Shad': [],
      'James': [{player: 'GB', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 57,
    timestamp: '2023-06-05T02:49:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [],
      'DigitalDude': [],
      'Gajeel': [],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 94,
    timestamp: '2023-06-05T07:33:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}],
      'DigitalDude': [],
      'Gajeel': [],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 113,
    timestamp: '2023-06-05T10:26:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}],
      'DigitalDude': [],
      'Gajeel': [],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 125,
    timestamp: '2023-06-05T10:55:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}],
      'DigitalDude': [],
      'Gajeel': [],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 135,
    timestamp: '2023-06-05T11:15:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}],
      'DigitalDude': [],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 158,
    timestamp: '2023-06-05T11:56:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}],
      'DigitalDude': [],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}],
      'Holt': [],
    }
  },
  {
    id: 176,
    timestamp: '2023-06-05T12:26:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}],
      'DigitalDude': [],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}],
      'Holt': [],
    }
  },
  {
    id: 178,
    timestamp: '2023-06-05T12:37:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}],
      'DigitalDude': [],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}],
      'Holt': [],
    }
  },
  {
    id: 183,
    timestamp: '2023-06-05T12:55:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}],
      'Holt': [],
    }
  },
  {
    id: 183,
    timestamp: '2023-06-05T13:38:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}, {player: 'BakaTai', lock: true}],
      'Holt': [],
    }
  },
  {
    id: 209,
    timestamp: '2023-06-05T13:40:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}, {player: 'BakaTai', lock: true}, {player: 'Tatsu', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 226,
    timestamp: '2023-06-05T14:09:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}, {player: 'Marmalade', lock: true}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}, {player: 'BakaTai', lock: true}, {player: 'Tatsu', lock: false}],
      'Holt': [],
    }
  },
  {
    id: 233,
    timestamp: '2023-06-05T14:18:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}, {player: 'Marmalade', lock: true}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}, {player: 'BakaTai', lock: true}, {player: 'Tatsu', lock: false}, {player: 'GrySun', lock: true}],
      'Holt': [],
    }
  },
  {
    id: 247,
    timestamp: '2023-06-05T14:28:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}, {player: 'Marmalade', lock: true}, {player: 'GB', lock: true}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}, {player: 'BakaTai', lock: true}, {player: 'Tatsu', lock: false}, {player: 'GrySun', lock: true}],
      'Holt': [],
    }
  },
  {
    id: 251,
    timestamp: '2023-06-05T14:28:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}, {player: 'Marmalade', lock: true}, {player: 'GB', lock: true}, {player: 'DigitalDude', lock: true}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}, {player: 'BakaTai', lock: true}, {player: 'Tatsu', lock: false}, {player: 'GrySun', lock: true}],
      'Holt': [],
    }
  },
  {
    id: 253,
    timestamp: '2023-06-05T14:29:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}, {player: 'Marmalade', lock: true}, {player: 'GB', lock: true}, {player: 'DigitalDude', lock: true}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}, {player: 'BakaTai', lock: true}, {player: 'Tatsu', lock: false}, {player: 'GrySun', lock: true}, {player: 'James', lock: true}],
      'Holt': [],
    }
  },
  {
    id: 254,
    timestamp: '2023-06-05T14:29:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}, {player: 'Marmalade', lock: true}, {player: 'GB', lock: true}, {player: 'DigitalDude', lock: true}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}, {player: 'BakaTai', lock: true}, {player: 'Tatsu', lock: false}, {player: 'GrySun', lock: true}, {player: 'James', lock: true}, {player: 'Shad', lock: true}],
      'Holt': [],
    }
  },
  {
    id: 255,
    timestamp: '2023-06-05T14:29:00.000Z',
    players: {
      'BakaTai': [],
      'Margi': [],
      'Grysun': [{player: 'Shad', lock: false}, {player: 'Marmalade', lock: false}],
      'Erinyes': [{player: 'DigitalDude', lock: false}],
      'Tatsu': [{player: 'Erinyes', lock: false}, {player: 'GrySun', lock: false}, {player: 'James', lock: false}, {player: 'Marmalade', lock: true}, {player: 'GB', lock: true}, {player: 'DigitalDude', lock: true}, {player: 'Margi', lock: false}],
      'DigitalDude': [{player: 'Bran', lock: false}],
      'Gajeel': [{player: 'Holt', lock: false}],
      'Shad': [{player: 'Sam', lock: false}],
      'James': [{player: 'GB', lock: false}, {player: 'BakaTai', lock: false}],
      'Brandish': [],
      'Sam': [],
      'GB': [],
      'Marmalade': [{player: 'Gajeel', lock: false}, {player: 'Anon Vote', lock: true, annon: true}, {player: 'BakaTai', lock: true}, {player: 'Tatsu', lock: false}, {player: 'GrySun', lock: true}, {player: 'James', lock: true}, {player: 'Shad', lock: true}],
      'Holt': [],
    }
  }
]
